module.exports = __webpack_public_path__ + "img/ECGSYSCS4.b7350c89.jpg";